import * as React from 'react';
import {NormalEdit} from "components/EditableTable/index";

export const KeyDeliverables = (
    <div>
        <NormalEdit/>
    </div>
);